// eslint-disable-next-line no-unused-vars
import React from "react";
import PropTypes from "prop-types";
import "./SwissBillingPaymentType.scss";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { SWISSBILLING_INVOICE_TYPES, AGE_RANGE } from "app/constants";
import InfoPopover from "app/components/ui/InfoPopover/InfoPopover";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import DateSelectorInputFormik from "app/pages/.shared/DateSelector/DateSelectorInputFormik";
import { useFormikContext } from "formik";
import RadioFormik from "app/pages/.shared/form/RadioFormik";
import "app/pages/.shared/PictoRadio.scss";
import RadioPictoContent from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/SwissBilling/RadioPictoContent";

const SwissBillingPaymentType = ({ total, swissBillingCGVURL, maxAmount }) => {
	const { setFieldError } = useFormikContext();

	return (
		<div className="swissbilling-payment-type">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				isBold
				className="swissbilling-payment-type__pay-amount"
			>
				<FormattedMessage id="payment.pay.all.without.fees" />
				<span>
					<AmountContainer amount={total} />
				</span>
			</Typography>
			<div className="swissbilling-payment-type__info">
				<FormattedMessage
					id="swissbilling.info.paragraph"
					values={{
						popover: (
							<InfoPopover iconSize={12}>
								<FormattedMessage
									id="swissbilling.info.popover.text"
									values={{
										cgvLink: (
											<a
												rel="noopener noreferrer"
												target="_blank"
												href={swissBillingCGVURL}
											>
												<FormattedMessage id="swissbilling.info.popover.cgv.label" />
											</a>
										),
										maxAmount: maxAmount,
									}}
								/>
							</InfoPopover>
						),
					}}
				/>
			</div>
			<div className="swissbilling-payment-type__birthdate">
				<DateSelectorInputFormik
					formatMonth="short"
					label={<FormattedMessage id="swissbilling.birthdate.label" />}
					id="swissbilling-birthdate"
					name="payment.swissBilling.birthdate"
					isRequired
					rangeYear={AGE_RANGE.FROM_18}
				/>
			</div>

			<div className="swissbilling-payment-type__invoice-type">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="swissbilling-payment-type__invoice-type__note"
				>
					<FormattedMessage id="swissbilling.invoice.type.note" />
				</Typography>
				<div className="swissbilling-payment-type__invoice-type__radio-group">
					{Object.values(SWISSBILLING_INVOICE_TYPES).map((value, index) => (
						<div
							key={index}
							className="swissbilling-payment-type__invoice-type__radio-group__item"
						>
							<div className="picto-radio">
								<RadioFormik
									name="payment.swissBilling.invoiceType"
									id={`swissbilling-invoiceType-${value}`}
									value={value}
									toggle={() => {
										setFieldError("payment.swissBilling.invoiceType");
									}}
								>
									<RadioPictoContent type={value} />
								</RadioFormik>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

SwissBillingPaymentType.propTypes = {
	total: PropTypes.number,
	swissBillingCGVURL: PropTypes.string,
	maxAmount: PropTypes.string,
};

export default SwissBillingPaymentType;
